// Components both Activity tabs share.
import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/** A request id as a link: shows its tail, filters the page to that request. */
export function RequestLink({ id, onRequestId }) {
  if (!id) return <span style={{ opacity: 0.5 }}>·</span>;
  return (
    <Link
      component="button"
      underline="hover"
      title={`Everything from request ${id}`}
      onClick={(e) => {
        e.stopPropagation();
        onRequestId(id);
      }}
      sx={{ fontFamily: "monospace", fontSize: "0.8rem" }}
    >
      {id.slice(-8)}
    </Link>
  );
}

export function KV({ k, v }) {
  if (v === null || v === undefined || v === "") return null;
  return (
    <Box sx={{ display: "flex", gap: 2, py: 0.25 }}>
      <Typography variant="body2" color="text.secondary" sx={{ width: 120, flexShrink: 0 }}>
        {k}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: "monospace", wordBreak: "break-all" }}>
        {String(v)}
      </Typography>
    </Box>
  );
}

export function Pre({ children, tone }) {
  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        p: 1.5,
        borderRadius: 1,
        maxHeight: 320,
        overflow: "auto",
        fontSize: "0.75rem",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        bgcolor: tone === "error" ? "rgba(211,47,47,0.08)" : "rgba(0,0,0,0.04)",
      }}
    >
      {children}
    </Box>
  );
}

/** Row detail: the row's fields, then links that pivot the page. */
export function DetailDialog({ title, onClose, actions = [], children }) {
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pr: 6 }}>
        {title}
        <IconButton aria-label="Close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {children}
        {actions.length > 0 && (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 1.5 }}>
            {actions.map((a) => (
              <Button key={a.label} size="small" onClick={a.onClick}>
                {a.label} →
              </Button>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
